import React from 'react';
import { useNavigate } from 'react-router-dom';
import ResponsiveTable from './ResponsiveTable';

function ClientsTable({ data, totalCount, currentPage, pageSize, searchKeyword }) {
  const navigate = useNavigate();

  const columns = React.useMemo(
    () => [
      {
        Header: () => <div className="whitespace-nowrap text-center">순번</div>,
        accessor: (_row, i) => totalCount - ((currentPage - 1) * pageSize + i),
        id: 'row',
        Cell: ({ value }) => (
          <div className="text-center whitespace-nowrap">{value}</div>
        ),
      },
      {
        Header: 'ID',
        accessor: 'loginId',
      },
      {
        Header: '권리사명',
        accessor: 'name',
        Cell: ({ row }) => (
          <span
            className="font-bold text-sky-400 cursor-pointer hover:underline"
            onClick={() => {
              const searchParam = searchKeyword ? `&search=${encodeURIComponent(searchKeyword)}` : '';
              navigate(`/Clients/${row.original.id}?page=${currentPage}${searchParam}`);
            }}>
            {row.original.name}
          </span>
        ),
      },
      {
        Header: '닉네임',
        accessor: 'nickName',
      },
      {
        Header: '연락처',
        accessor: (row) => `${row.phone1}-${row.phone2}-${row.phone3}`,
        id: 'phone',
      },
      {
        Header: '이메일',
        accessor: (row) => `${row.emailId}@${row.emailDomain}`,
        id: 'email',
      },
      {
        Header: '유형',
        accessor: 'type',
      },
    ],
    [navigate, totalCount, currentPage, pageSize, searchKeyword]
  );

  return (
    <ResponsiveTable
      columns={columns}
      data={data}
      visibleOnMobile={['row', 'loginId', 'name', 'phone']}
    />
  );
}

export default ClientsTable;
